import { format } from "date-fns";

export const toYesNo = (value: boolean) => (value ? "Ja" : "Nej");

export const toPrettyDate = (date: string) =>
  format(new Date(date), "yyyy-MM-dd");

export const toPrettyUrl = (url: string) =>
  url.replace("https://", "").replace("http://", "");
